<template>
	<div class="RecetaIngredientesHandler">
		<spinner v-if="isLoading" />
		<template v-else>

			<b-row id="RecetaIngredientesHandlerHolder">

				<b-col>
					<b-form-input variant="primary" size="sm" :id="invSearchID"></b-form-input>
				</b-col>

				<b-col md="8" v-if="adding.id_ingrediente_fk">
					<b-input-group size="sm">
						<template #prepend>
							<b-input-group-text>Cantidad:</b-input-group-text>
						</template>

						<b-form-input type="number" v-model="adding.cantidad" step="0.1" min="0.1" placeholder="Cantidad"/>

						<b-form-select size="sm" v-model="adding.id_unidadmedicion_fk">
							<b-form-select-option :value="null" disabled>--</b-form-select-option>
							<b-form-select-option v-for="um in filteredUM" :value="um.id_pk" :key="um.id_pk">
								{{um.nombre}}
							</b-form-select-option>
						</b-form-select>

						<template #append>
							<b-button variant="primary" @click="validateAndAddItem()">
								<i class="fa fa-plus"></i>
							</b-button>
						</template>
					</b-input-group>
				</b-col>
			</b-row>

			<b-jumbotron v-if="workingValue.length == 0" header="No hay ingredientes" lead="Agrega ingredientes para continuar" />

			<b-col class="item-holder" v-for="(ing, $index) in workingValue" :key="ing.id_ingrediente_fk">
				<b-input-group size="xs" :append="ing.unidadmedicionTXT"> 
					<template #append> 
						<b-button variant="outline-primary" v-if="isIngredientNutritionalyValidated(ing.id_ingrediente_fk)" title="Elementos nutricionales completos" key="check" disabled>
							<i class="fa fa-check-circle"></i>
						</b-button>
						<b-button variant="outline-info" disabled v-else title="Elementos nutricionales incompletos" key="uncheck">
							<i class="fa fa-circle"></i>
						</b-button>
						<b-button variant="danger" @click="askForIngredientRemoval(ing.id_ingrediente_fk)"> 
							<i class="fa fa-trash"></i> 
						</b-button> 
					</template>
					<b-form-input v-model="ing.fullIng.text" disabled></b-form-input>
					<b-form-input type="number" v-model="workingValue[$index].cantidad" step="0.1" min="0.1" placeholder="Cantidad" />
				</b-input-group>
			</b-col>

			<div class="p-2 pb-0 text-center" v-if="workingValue.length">
				<b-alert v-if="computedGeneralValidation" variant="success" show>
					Esta receta se puede calcular nutricionalmente de manera automática
				</b-alert>
				<b-alert v-else variant="info" show>
					Para calcular los elementos nutricionales de esta receta de manera automática todos los ingredientes deben estar validados.
				</b-alert>
			</div>
		</template>
	</div>
</template>

<script>
import mobiscroll from "@mobiscroll/javascript";
import swal from "sweetalert";
import _ from "lodash";
import axios from "axios";
import {recoverNutritionalStatus, isIngredientNutritionalyValidated, computedGeneralValidation} from './recoverNutritionalStatus'

let formEmptyItem = {
	id_pk: null,
	cantidad: 1,
	id_unidadmedicion_fk: null,
	observaciones: null,
	id_ingrediente_fk: null,
	id_encabezado_fk: null,
	id_ultimo_usuario_fk: null,
	ultima_actualizacion: null,
	fullIng: {
		asides: {
			idunidad_fk_available: [],
		},
	},
};

export default {
	name: "RecetaIngredientesHandler",
	components: {},
	props: {
		value: {
			type: Array,
		},
	},
	data: () => {
		return {
			isLoading: false,
			invSearchID: null,
			workingValue: [],
			toAdd: {},
			adding: _.clone(formEmptyItem),
			mobi: null,
			asides: {
				unidadmedicion: [],
			},
			ingNutritionalStatus: []
		};
	},
	computed: {
		computedURI() {
			return axios.defaults.baseURL + "/origins/elementos/ingredientes/";
		},
		filteredUM() {
			if (!this.adding) return [];
			return _.filter(this.asides.unidadmedicion, (item) => {
				return ( this.adding.fullIng.asides.idunidad_fk_available.indexOf(item.id_pk) != -1 );
			});
		},
		computedGeneralValidation(){
			return computedGeneralValidation(this.workingValue, this.ingNutritionalStatus)
		}
	},
	methods: {
		async recoverNutritionalStatus(){
			this.ingNutritionalStatus = await recoverNutritionalStatus(this.workingValue)
			this.$forceUpdate()
		},
		async askForIngredientRemoval(id_ingrediente_fk) {
			const swalResposne = await swal({
				title: "Seguro que deseas eliminar el ingrediente",
				buttons: {
					cancel: "Cancelar",
					danger: "Quita el ingrediente",
				},
			});
			if (swalResposne == "danger") {
				const position = _.findIndex(this.workingValue, {
					id_ingrediente_fk,
				});
				this.workingValue.splice(position, 1);
			}
		},
		async loadUp() {
			try {
				let response = await axios.get("origins/unidadmedicion");
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg) {
					mobiscroll.snackbar({
						display: "top",
						theme: "ios",
						message: response.msg,
						color: response.class,
						duration: 7000,
					});
				}

				// STATUS REV
				if (response.status) {
					this.asides.unidadmedicion = response.data.unidadmedicion;
				}

				let fullIng = []
				_.forEach(this.workingValue, item => {
					fullIng.push(item.id_ingrediente_fk)
				})
				if(fullIng.length){
					let fullIngData = await axios.get("/origins/elementosfromlist/ingredientes/" + fullIng.toString())
					_.forEach(fullIngData.data, item => {
						_.map(this.workingValue, val => {
							if(parseInt(item.value) == parseInt(val.id_ingrediente_fk)) {
								let umSelected = _.find(this.asides.unidadmedicion, {
									id_pk: val.id_unidadmedicion_fk,
								});
								val.id_ingrediente_fk 			= parseInt(val.id_ingrediente_fk)
								val.unidadmedicionTXT 			= umSelected.nombre;
								val.fullIng = item
								return val
							}
						})
					})
				}
			} catch (e) {
				console.error(e);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message:
						"Ocurrió un error obteniendo las unidades de medida: " +
						e,
					color: "warning",
					duration: 7000,
				});
			}
		},
		loadUpMobiscroll() {
			if (!this.mobi) {
				this.mobi = mobiscroll.select("#" + this.invSearchID, {
					display: "bubble",
					inputClass: "form-control form-control-sm",
					placeholder: "Busca un ingrediente",
					filter: true,
					fullData: [],
					label: "Busca el ingrediente que deseas incluír en la receta",
					data: {
						remoteFilter: true,
						url: this.computedURI,
						type: "json",
						processResponse: (response) => {
							this.fullData = [];
							if (response.status && response.data) {
								this.fullData = _.map(response.data, (item) => {
									return {
										value: item.value,
										text: item.text,
										html: `<p>${item.text}</p>`,
										item: _.clone(item),
									};
								});
							} else {
								this.fullData = [
									{
										value: null,
										text: "Nada encontrado",
										html: "<p>Nada encontrado</p>",
										item: {},
									},
								];
							}
							return this.fullData;
						},
					},
					onSet: (a, b) => {
						let itemSelected = _.find(this.fullData, {
							value: b.getVal(),
						});
						itemSelected.asides = _.clone(itemSelected.item.asides);
						delete itemSelected.item.asides;
						this.adding.fullIng = itemSelected;
						this.adding.id_ingrediente_fk = b.getVal();
					},
				});
			}
		},
		validateAndAddItem() {
			let isValid = true,
				preFind = _.findIndex(this.workingValue, {
					id_ingrediente_fk: this.adding.id_ingrediente_fk,
				});

			_.forEach(
				"cantidad, id_unidadmedicion_fk, id_ingrediente_fk".split(", "),
				(val) => {
					if (
						this.adding[val] == null ||
						this.adding[val] == "" ||
						this.adding[val] <= 0
					) {
						// NO ES VÁLIDO
						isValid = false;

						// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
						swal({
							title: "Debes especificar ingrediente, cantidad y unidad de medida para continuar.",
							icon: "info",
						});
					} else if (preFind != -1) {
						// TAMPOCO ES VÁLIDO
						isValid = false;

						// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
						swal({
							title: "Ese ingrediente ya está en la receta...",
							icon: "info",
						});
					}
				}
			);
			if (isValid) {
				let umSelected = _.find(this.asides.unidadmedicion, {
					id_pk: this.adding.id_unidadmedicion_fk,
				});
				this.adding.unidadmedicionTXT = umSelected.nombre;
				this.workingValue.push(_.clone(this.adding));
				this.adding = _.clone(formEmptyItem);
				if(_.isObjectLike(this.mobi) && _.isFunction(this.mobi.clear)) this.mobi.clear();
				this.recoverNutritionalStatus()
			}
		},
		isIngredientNutritionalyValidated
	},
	watch: {
		computedGeneralValidation(){
			if(!this.isLoading)
				this.$emit('canBeUpdated', this.computedGeneralValidation)
		},
		value(){
			if(JSON.stringify(this.workingValue) != JSON.stringify(this.value))
				this.workingValue = _.clone(this.value)
		},
		workingValue() {
			this.$emit("input", this.workingValue);
		}
	},
	beforeMount() {
		this.invSearchID = _.uniqueId("invSearch-");
	},
	async mounted() {
		this.isLoading = true;
		this.workingValue = _.clone(this.value);
		await this.recoverNutritionalStatus(this.workingValue)
		await this.loadUp();
		this.isLoading = false;
		// GENERAL LOADING AFTER LOADUP
		setTimeout(this.loadUpMobiscroll, 50);
	},
};
</script>

<style lang="less">
.RecetaIngredientesHandler {
	#RecetaIngredientesHandlerHolder {
		margin-bottom: 1em;
		padding-bottom: 1em;
		border-bottom: 1px solid hsla(0, 0%, 0%, 0.2);
	}
	.item-holder {
		padding: 0.5em;
		INPUT:disabled {
			flex: 0 calc(60% - 3em);
			color: var(--primary);
			font-weight: bold;
		}
		:last-child {
			text-align: right;
		}
	}
}
</style>